import React from "react";

import { graphql } from "gatsby";

import OptimizedImage from "cms/components/OptimizedImage";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";

import {
  CardContainer,
  Container,
  Content,
  Description,
  HeadlineContainer,
  IconImageContainer,
  Illustration,
} from "./TwoCardBlock.styles";

export interface TwoCardBlockProps extends Queries.SanityTwoCardBlock {}

const TwoCardBlock: React.FC<TwoCardBlockProps> = ({
  headlineLeftCard,
  _rawPitchLeftCard,
  imageLeftCard,
  imageAltLeftCard,
  iconImageLeftCard,
  iconImageAltLeftCard,
  headlineRightCard,
  _rawPitchRightCard,
  imageRightCard,
  imageAltRightCard,
  iconImageRightCard,
  iconImageAltRightCard,
}) => (
  <Container>
    <Content>
      <CardContainer>
        {iconImageLeftCard && (
          <IconImageContainer>
            <OptimizedImage
              image={iconImageLeftCard}
              alt={iconImageAltLeftCard}
            />
          </IconImageContainer>
        )}

        <HeadlineContainer>
          <Text variant="H3" as="h3">
            {headlineLeftCard}
          </Text>
        </HeadlineContainer>
        <Description>
          <RichText text={_rawPitchLeftCard} />
        </Description>
        {imageLeftCard && (
          <Illustration>
            <OptimizedImage image={imageLeftCard} alt={imageAltLeftCard} />
          </Illustration>
        )}
      </CardContainer>

      <CardContainer>
        {iconImageRightCard && (
          <IconImageContainer>
            <OptimizedImage
              image={iconImageRightCard}
              alt={iconImageAltRightCard}
            />
          </IconImageContainer>
        )}

        <HeadlineContainer>
          <Text variant="H3" as="h3">
            {headlineRightCard}
          </Text>
        </HeadlineContainer>
        <Description>
          <RichText text={_rawPitchRightCard} />
        </Description>
        {imageRightCard && (
          <Illustration>
            <OptimizedImage image={imageRightCard} alt={imageAltRightCard} />
          </Illustration>
        )}
      </CardContainer>
    </Content>
  </Container>
);

export const query = graphql`
  fragment TwoCardBlock on SanityTwoCardBlock {
    _key
    _type
    headlineLeftCard
    _rawPitchLeftCard(resolveReferences: { maxDepth: 5 })
    imageLeftCard {...OptimizedImage}
    imageAltLeftCard
    iconImageLeftCard {...OptimizedImage}
    iconImageAltLeftCard
    headlineRightCard
    _rawPitchRightCard(resolveReferences: { maxDepth: 5 })
    imageRightCard {...OptimizedImage}
    imageAltRightCard
    iconImageRightCard {...OptimizedImage}
    iconImageAltRightCard
  }
`;

export default TwoCardBlock;
